interface Product {
  title: string
  editionLabel: string
  priceNumber: number
  priceText: string
  thumbnailUrl: string
}

export function scanPageForProducts(): Product[] {
  const products: Product[] = []

  try {
    // Strategy 1: Look for pricing sections with product info
    const pricingSection = document.querySelector('#pricing')

    if (pricingSection) {
      // Extract title
      const titleElement = pricingSection.querySelector('h3')
      const title = titleElement?.textContent?.trim() || 'Mega Music Pack'

      // Extract edition/subtitle
      const subtitleElement = pricingSection.querySelector('h3 + p')
      const editionLabel =
        subtitleElement?.textContent?.trim() ||
        'Complete Teacher Resource Bundle'

      // Extract price - look for the main price (not crossed out)
      const priceElements = pricingSection.querySelectorAll('span')
      let priceText = '$17 USD'
      let priceNumber = 17

      for (const el of Array.from(priceElements)) {
        const text = el.textContent?.trim() || ''
        // Look for price that's not line-through
        if (
          text.includes('$') &&
          !el.classList.contains('line-through') &&
          text.includes('17')
        ) {
          priceText = text
          const match = text.match(/\$?\s?(\d+(?:\.\d{2})?)/)
          if (match) {
            priceNumber = parseFloat(match[1])
          }
          break
        }
      }

      // Extract thumbnail - look for product images
      let thumbnailUrl =
        'https://cdn.magicpatterns.com/uploads/7Wqh6nPDy9ddxsoQhhnDTr/IMG-M01.png'
      const heroSection = document.querySelector('#hero')
      const heroImage = heroSection?.querySelector('img')
      if (heroImage?.src) {
        thumbnailUrl = heroImage.src
      }

      products.push({
        title,
        editionLabel,
        priceNumber,
        priceText,
        thumbnailUrl,
      })
    }
  } catch (error) {
    console.warn('Product scanning failed, using fallback', error)
  }

  // Fallback if no products found
  if (products.length === 0) {
    products.push({
      title: 'Mega Music Pack',
      editionLabel: 'Complete Teacher Resource Bundle',
      priceNumber: 17,
      priceText: '$17 USD',
      thumbnailUrl:
        'https://cdn.magicpatterns.com/uploads/7Wqh6nPDy9ddxsoQhhnDTr/IMG-M01.png',
    })
  }

  return products
}

export function getRandomProduct(products: Product[]): Product {
  return products[Math.floor(Math.random() * products.length)]
}
